import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    logs: [],
};

const cuePointsLogsSlice = createSlice({
    name: 'cuePointsLogs',
    initialState,
    reducers: {
        addCueLogs(state, action) {
            if (Array.isArray(action.payload) && action.payload.length > 0) {
                state.logs = [...action.payload, ...state.logs];
            }
        },
        // Add or update a per-file log keyed by filePath.
        updateOrAddCueLogs(state, action) {
            if (!Array.isArray(action.payload)) return;
            action.payload.forEach((newLog) => {
                if (newLog.filePath) {
                    const i = state.logs.findIndex((l) => l.filePath === newLog.filePath);
                    if (i !== -1) state.logs[i] = newLog;
                    else state.logs = [newLog, ...state.logs];
                } else {
                    state.logs = [newLog, ...state.logs];
                }
            });
        },
        clearCueLogs(state) {
            state.logs = [];
        },
    },
});

export const { addCueLogs, updateOrAddCueLogs, clearCueLogs } = cuePointsLogsSlice.actions;
export default cuePointsLogsSlice.reducer;
